/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getReleaseSchedule} from '../api'

 export const useQueryGetReleaseSchedule = createReactQueryHook('getReleaseSchedule', getReleaseSchedule)
